import {
  Badge,
  Box,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  Heading,
  HStack,
  Icon,
  SimpleGrid,
  Stack,
  Tag,
  Text,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { FiSearch, FiUsers } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getMateriasByGrado, reset } from '../../features/materiaSlice';
import { Loading } from '../../helpers/Loading';
import ModalVerHorarioMateria from './ModalVerHorarioMateria';

const MateriasPorGrado = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { materias, isLoading } = useSelector(state => state.materias);

  useEffect(() => {
    dispatch(getMateriasByGrado(id));

    return () => {
      dispatch(reset());
    };
  }, [id, dispatch]);

  const hoverEffect = {
    transform: 'translateY(-2px)',
    transition: 'all 0.5s ease',
    boxShadow: 'base',
  };

  if (isLoading) return <Loading />;

  return (
    <Box>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} spacing={4}>
        {materias?.map(course => (
          <Card
            key={course._id}
            borderTop="8px solid"
            borderColor={course.brand_color || '#000000'}
            borderRadius={'2xl'}
            _dark={{
              borderColor: course.brand_color,
              bg: 'primary.1000',
              color: 'white',
              _hover: { bg: 'primary.900' },
            }}
            _hover={hoverEffect}
            variant="elevated"
            position="relative"
            overflow="hidden"
          >
            <CardHeader>
              <Stack
                direction={['column', 'row']}
                justifyContent="space-between"
                alignItems="center"
              >
                <Heading size="md">{course.nombre}</Heading>
                <Tag colorScheme={'primary'} px={2} py={1} color={'white'}>
                  GRADO: {course.grado.nombre}
                </Tag>
              </Stack>
            </CardHeader>
            <CardBody>
              <Flex
                direction="column"
                justify="space-between"
                h="full" // Aseguramos que ocupe toda la altura
                gap={4}
              >
                {/* Descripción que ocupa el espacio disponible */}
                <Box flex={1}>
                  <Text noOfLines={3} color="gray.500" fontSize={'sm'} h="full">
                    {course?.descripcion}
                  </Text>
                </Box>
                <Box>
                  <HStack spacing={4} w="full" justifyContent="flex-end">
                    <Text fontSize="sm" color="gray.500">
                      TOTAL DE ESTUDIANTES
                    </Text>
                    <Badge
                      colorScheme="primary"
                      color={'white'}
                      px={3}
                      py={1}
                      borderRadius="full"
                      flexShrink={0}
                    >
                      <HStack spacing={1} w={'full'}>
                        <Icon as={FiUsers} />
                        <Text>{course.totalEstudiantes}</Text>
                      </HStack>
                    </Badge>
                  </HStack>
                </Box>
              </Flex>
            </CardBody>

            <CardFooter borderTopWidth="1px">
              <Stack justifyContent="space-between" direction={['column', 'row']} w="full">
                <Button
                  variant="outline"
                  w={'full'}
                  colorScheme="primary"
                  rightIcon={<FiSearch color="primary.500" />}
                  onClick={() => {
                    if (course?.grado?.nivel === 'INICIAL') {
                      return navigate(`/asignaturas/${course._id}/calificaciones-cualitativa`);
                    }
                    if (course?.esComportamental === true) {
                      return navigate(`/asignaturas/${course._id}/calificaciones-comportamental`);
                    }
                    return navigate(`/asignaturas/${course._id}`);
                  }}
                >
                  VER ESTUDIANTES
                </Button>
                <ModalVerHorarioMateria materia={course} />
              </Stack>
            </CardFooter>
          </Card>
        ))}
      </SimpleGrid>

      {materias?.length === 0 && (
        <Box textAlign="center" py={20}>
          <Text fontSize="xl" color="gray.500">
            NO TIENES ASIGNATURAS ASIGNADAS
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default MateriasPorGrado;
